<script lang="ts">
  export let name: string;
</script>

<main>
  <h1>hi, im {name}!</h1>
  <a href="https://github.com/memnyaa" target="_blank" rel="noopener noreferrer"
    >github</a
  >
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  h1 {
    color: #000000;
    text-transform: lowercase;
    font-size: 2.5em;
    font-weight: 80;
  }

  a {
    color: #000000;
    text-decoration: none;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
